export const iconFontAwesomeWeatherTemperatureArrowUp = (
	<i className="fa-solid fa-temperature-arrow-up"></i>
);
